<template>
<div class="chapter">
<div class="inner_page">
<p class="sp"> </p>
<p class="FM-Head-fmh-3"><span href="#/xhtml/contents#cglo" title="Link target outside of Sample"><span class="ePub-B">Glossary of Terms</span></span></p>
<p class="Glossary-Term-glt"><span class="ePub-I">BGF</span>—the Black Guerrilla Family gang</p>
<p class="Glossary-Term-glt"><span class="ePub-I">Dark Web</span>—an unindexed part of the Internet accessible only through an encrypted browser</p>
<p class="Glossary-Term-glt"><span class="ePub-I">dope, raw</span>—heroin</p>
<p class="Glossary-Term-glt"><span class="ePub-I">dope sick</span>—sickness caused by withdrawal from opiates</p>
<p class="Glossary-Term-glt"><span class="ePub-I">enforcer</span>—a gang member who commits homicides and other acts of violence to protect his gang’s interests</p>
<p class="Glossary-Term-glt"><span class="ePub-I">field marshal</span>—a high-ranking member of BGF; usually oversees a team of enforcers</p>
<p class="Glossary-Term-glt"><span class="ePub-I">Frankenstein</span>—heroin cut with fentanyl</p>
<p class="Glossary-Term-glt"><span class="ePub-I">hot shot</span>—a deadly dose of heroin</p>
<p class="Glossary-Term-glt"><span class="ePub-I">Percs</span>—Percocet</p>
<p class="Glossary-Term-glt"><span class="ePub-I">Pill City</span>—a Baltimore-based drug syndicate founded in April 2015</p>
<p class="Glossary-Term-glt"><span class="ePub-I">re-up</span>—to obtain a new supply of drugs from one’s supplier</p>
<p class="Glossary-Term-glt"><span class="ePub-I">rig</span>—a syringe</p>
<p class="Glossary-Term-glt"><span class="ePub-I">riot pills</span>—pills stolen during the April 2015 riots</p>
<p class="Glossary-Term-glt"><span class="ePub-I">Roxys</span>—Roxicodone</p>
<p class="Glossary-Term-glt"><span class="ePub-I">spike</span>—an unused needle</p>
<p class="Glossary-Term-glt"><span class="ePub-I">twin</span>—a communal syringe shared by multiple addicts</p>
<p class="Glossary-Term-glt"><span class="ePub-I">vacant</span>—an abandoned property, usually a rowhome, in Baltimore City</p>
<p class="Glossary-Term-glt"><span class="ePub-I">Vikes</span>—Vicodin</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// glossary.vue?1f3470a4